import { Modal } from "antd";
import type { FormInstance } from "antd";
import { useRef } from "react";
import { AddSingleLocation } from "./AddSingleLocation";

interface AddLocationModalProps {
	modalOpen: boolean;
	toggle: () => void;
	organization: string;
	onLocationAdded?: () => void;
}

const AddLocationModal = ({
	modalOpen,
	toggle,
	organization,
	onLocationAdded,
}: AddLocationModalProps) => {
	const toggleModal = () => {
		toggle();
	};

	const formRef = useRef<FormInstance>(null);

	const handleOk = () => {
		if (formRef.current) {
			formRef.current.submit();
		}
	};

	return (
		<Modal
			open={modalOpen}
			onCancel={toggleModal}
			centered
			title="Add Location"
			onOk={handleOk}
		>
			<AddSingleLocation
				formRef={formRef}
				modalOpen={modalOpen}
				toggleModal={toggleModal}
				onLocationAdded={onLocationAdded}
			/>
		</Modal>
	);
};

export { AddLocationModal };
